import basicScroll from 'basicscroll'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import serviceNav from '../components/service-navigation.svelte'

const { $ } = window

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {
		let $serviceNav = $('#pageNav nav')
		if ($serviceNav) {
			new serviceNav({
				target: $serviceNav[0],
				props: $serviceNav.data(),
			})
		}
		scrollReveals()
		parallax()
	},
	finalize() {},
}

function scrollReveals() {
	let $serviceItemsOdd = $('.intro-service-wrap:nth-of-type(odd)')
	let $serviceItemsEven = $('.intro-service-wrap:nth-of-type(even)')
	$serviceItemsOdd.each(function () {
		let serv_tl = gsap.timeline({
			scrollTrigger: {
				trigger: $(this)[0],
				start: 'top center+=300', // when the top of the trigger hits the center of the viewport
				// markers: true,
			},
		})
		serv_tl.fromTo(
			$(this)[0],
			{
				opacity: 0,
				x: 40,
			},
			{
				delay: 0.1,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
		if (!window.matchMedia('(max-width: 768px)').matches) {
			serv_tl.fromTo(
				$(this).find('.service-wrap-green-box .service-wrap-green-box-1')[0],
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					width: '100%',
				}
			)
			serv_tl.fromTo(
				$(this).find('.service-wrap-green-box .service-wrap-green-box-2')[0],
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					height: '100%',
				}
			)
			serv_tl.fromTo(
				$(this).find('.service-wrap-green-box .service-wrap-green-box-4')[0],
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					width: '100%',
				}
			)
			serv_tl.fromTo(
				$(this).find('.service-wrap-green-box .service-wrap-green-box-3')[0],
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					height: '100%',
				}
			)
		} else {
			serv_tl.fromTo(
				$(this).find(
					'.service-wrap-green-box-mobile .service-wrap-green-box-1'
				)[0],
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					width: '100%',
				}
			)
			serv_tl.fromTo(
				$(this).find(
					'.service-wrap-green-box-mobile .service-wrap-green-box-3'
				)[0],
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					height: '100%',
				}
			)
			serv_tl.fromTo(
				$(this).find(
					'.service-wrap-green-box-mobile .service-wrap-green-box-4'
				)[0],
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					width: '100%',
				}
			)
			serv_tl.fromTo(
				$(this).find(
					'.service-wrap-green-box-mobile .service-wrap-green-box-2'
				)[0],
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					height: '100%',
				}
			)
		}
	})
	$serviceItemsEven.each(function () {
		let serv_tl = gsap.timeline({
			scrollTrigger: {
				trigger: $(this)[0],
				start: 'top center+=300', // when the top of the trigger hits the center of the viewport
				// markers: true,
			},
		})
		serv_tl.fromTo(
			$(this)[0],
			{
				opacity: 0,
				x: -40,
			},
			{
				delay: 0.1,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
		if (!window.matchMedia('(max-width: 768px)').matches) {
			serv_tl.fromTo(
				$(this).find(
					'.section-img-wrap .service-wrap-green-box .service-wrap-green-box-1'
				)[0],
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					width: '100%',
				}
			)
			serv_tl.fromTo(
				$(this).find('.service-wrap-green-box .service-wrap-green-box-3')[0],
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					height: '100%',
				}
			)
			serv_tl.fromTo(
				$(this).find('.service-wrap-green-box .service-wrap-green-box-4')[0],
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					width: '100%',
				}
			)
			serv_tl.fromTo(
				$(this).find('.service-wrap-green-box .service-wrap-green-box-2')[0],
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					height: '100%',
				}
			)
		} else {
			serv_tl.fromTo(
				$(this).find(
					'.service-wrap-green-box-mobile .service-wrap-green-box-1'
				)[0],
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					width: '100%',
				}
			)
			serv_tl.fromTo(
				$(this).find(
					'.service-wrap-green-box-mobile .service-wrap-green-box-3'
				)[0],
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					height: '100%',
				}
			)
			serv_tl.fromTo(
				$(this).find(
					'.service-wrap-green-box-mobile .service-wrap-green-box-4'
				)[0],
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					width: '100%',
				}
			)
			serv_tl.fromTo(
				$(this).find(
					'.service-wrap-green-box-mobile .service-wrap-green-box-2'
				)[0],
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.5,
					opacity: 1,
					height: '100%',
				}
			)
		}
	})
}

function parallax() {
	let scrollAnimations = []

	scrollAnimations.push(
		basicScroll.create({
			elem: $('.main-content-wrap .compass-svg')[0],
			from: 'top-bottom',
			to: 'bottom-top',
			direct: true,
			props: {
				'--sty':
					innerWidth > 600
						? {
								from: '-49.5%',
								to: '-59%',
						  }
						: {
								from: '-49.5%',
								to: '-59%',
						  },
			},
		})
	)

	if (scrollAnimations.length) {
		scrollAnimations.forEach((instance) => instance.start())
	}
}
